/** Must match RLS on early_access_signups / usuarios and SuperAdminRoute / sidebar. */
export const AUTHORIZED_SUPER_ADMIN_EMAIL = 'hola@clientelo.com.co';

/** Super-admin access is granted to any address on this domain (Clientelo staff). */
export const SUPER_ADMIN_EMAIL_DOMAIN = 'clientelo.com.co';

/**
 * True when the email belongs to the Clientelo super-admin domain.
 * Mirrors public.is_super_admin() in the database
 * (lower(email) LIKE '%@clientelo.com.co').
 */
export function isSuperAdminEmail(email: string | null | undefined): boolean {
  const e = (email ?? '').trim().toLowerCase();
  return e.endsWith(`@${SUPER_ADMIN_EMAIL_DOMAIN}`);
}
